import React, { useState, useEffect, useRef } from "react";
import { Col, Grid } from "antd";
import { useTranslation } from "react-i18next";

import { CloseIcon, DownloadIcon, NoDataIcon } from "icons";
import { generateImg, handleCheckValue } from "utils";

import {
  BoxItem4Chart,
  WrapperCloseIcon,
  BoxHeader,
  BoxTitle,
  LightDivider4Chart,
  BoxContent4Chart,
  WrapperLegend,
  RedRectangle,
  YellowRectangle,
} from "../Dashboard.style";
import PieChart from "./PieChart";
import { IChart } from "../BodyTemperatureResult";

const { useBreakpoint } = Grid;

const COLORS = ["#E0E0E0", "#EBC300", "#FB4E4E"];

const PercentageOfFever: React.FC<IChart> = ({ data, handleCloseChart }) => {
  const { t } = useTranslation("translation", {
    keyPrefix: "body-temperature",
  });

  const imgRef = useRef<any>();
  const screens = useBreakpoint();
  const [dataChart, setDataChart] = useState({
    value: [],
    total: 0,
    compared: 0,
  });

  useEffect(() => {
    console.log(data);
    if (
      handleCheckValue(data?.pie_temperatures_no_heat_per) &&
      handleCheckValue(data?.pie_temperatures_single_heat_per) &&
      handleCheckValue(data?.pie_temperatures_high_heat_per) &&
      handleCheckValue(data?.pie_temperatures_single_heat) &&
      handleCheckValue(data?.pie_temperatures_high_heat) &&
      handleCheckValue(data?.prev_pie_high_and_single_temperatures_total)
    ) {
      const value: any = [
        { value: data?.pie_temperatures_no_heat_per },
        { value: data?.pie_temperatures_single_heat_per },
        { value: data?.pie_temperatures_high_heat_per },
      ];
      const total =
        data?.pie_temperatures_single_heat + data?.pie_temperatures_high_heat;
      const compared =
        data?.pie_temperatures_single_heat +
        data?.pie_temperatures_high_heat -
        data?.prev_pie_high_and_single_temperatures_total;

      setDataChart({
        value,
        total,
        compared,
      });
    }
  }, [data]);

  return (
    <Col xs={24} md={12} xl={6} ref={imgRef}>
      <BoxItem4Chart>
        <WrapperCloseIcon>
          <CloseIcon
            fill="#2F8CAE"
            height="14px"
            width="14px"
            onClick={() => handleCloseChart("percentageOfFever")}
          />
        </WrapperCloseIcon>
        <BoxHeader>
          <BoxTitle>{t("percentage-fever")}</BoxTitle>
          <DownloadIcon
            fill="#3B3B3B"
            style={{ marginTop: 4, cursor: "pointer" }}
            onClick={(event: any) => {
              if (!event.detail || event.detail == 1) {
                generateImg("percentage-fever", imgRef.current);
              }
            }}
          />
        </BoxHeader>
        <LightDivider4Chart />
        <BoxContent4Chart>
          {dataChart.value.length ? (
            <React.Fragment>
              <PieChart
                data={dataChart.value}
                colors={COLORS}
                total={dataChart.total}
                compared={dataChart.compared}
              />
              {screens.xl && (
                <>
                  <WrapperLegend style={{ marginTop: 16, marginBottom: 10 }}>
                    <YellowRectangle />
                    <p>
                      {t("low-grade-fever-percentage")}
                      <span>
                        {data?.pie_temperatures_single_heat_per || 0}%
                      </span>
                    </p>
                  </WrapperLegend>
                  <WrapperLegend>
                    <RedRectangle />
                    <p>
                      {t("high-fever-percentage")}
                      <span>{data?.pie_temperatures_high_heat_per || 0}%</span>
                    </p>
                  </WrapperLegend>
                </>
              )}
            </React.Fragment>
          ) : (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                marginTop: 17,
              }}
            >
              <NoDataIcon />
            </div>
          )}
        </BoxContent4Chart>
      </BoxItem4Chart>
    </Col>
  );
};

export default PercentageOfFever;
